import { INPUT_TYPES } from '@decodo/utils';

import { FormFieldProps } from '@/blocks/Scraper/types';

import FormSelectField from './FormSelectField';
import FormTextField from './FormTextField';

export const FormField = (props: FormFieldProps) => {
  const { param } = props;

  if (param.type === INPUT_TYPES.TEXT) {
    return <FormTextField {...props} />;
  }

  if (param.type === INPUT_TYPES.SELECT) {
    return <FormSelectField {...props} />;
  }

  return null;
};
